import { render, staticRenderFns } from "./PhaseCard.vue?vue&type=template&id=f17732ea&scoped=true&"
import script from "./PhaseCard.vue?vue&type=script&lang=ts&"
export * from "./PhaseCard.vue?vue&type=script&lang=ts&"
import style0 from "./PhaseCard.vue?vue&type=style&index=0&id=f17732ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17732ea",
  null
  
)

export default component.exports